import { RemainderDropdown } from './RemainderDropdown';
import { RepeatReminderDropdown } from './RepeatReminderDropdown';
import { CurrentDropdownProvider } from './hooks/useCurrentDropdown';
export function ReminderField() {
    return (<CurrentDropdownProvider>
      <RemainderDropdown />
      <RepeatReminderDropdown />
    </CurrentDropdownProvider>);
}
